/**
 * @generated SignedSource<<b08bc60240ab55a2df7ffa979076698c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbleShare_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSocialShareEmail_user">;
  readonly " $fragmentType": "PdpRespIconBubbleShare_user";
};
export type PdpRespIconBubbleShare_user$key = {
  readonly " $data"?: PdpRespIconBubbleShare_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbleShare_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSocialShareEmail_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "93c85ac652947769c71d3e69bebfcd4c";

export default node;
